export const mapStyle = () => ({
  "height": "100%",
  ".gmnoprint, .gm-style-cc, a": {
    display: "none !important",
  },
  "div": {
    borderRadius: "6px !important",
  },
  ".gm-fullscreen-control": {
    "position": "relative",
    "background": "#FEC20B !important",
    "borderRadius": "50% !important",
    "img": {
      filter: "brightness(0.6)",
    },
  },
});
